export class MensajePresidente {
  public idMensaje: number;
  public idTipoComunicacion: number;
  public tipoComunicacion: null;
  public mensaje: string;
  public vigenteDesde: string;
  public vigenteHasta: string;
  public contacto: string;
  public telefono: string;

  constructor() {}
}
